import React from 'react';
import SendEmailForm from './SendEmailForm';
import '../mail-form.css';
import { useFetchGmailAccounts } from 'query/gmail';

const SendEmail = () => {
  // preload gmail accounts;
  useFetchGmailAccounts();

  return (
    <>
      <SendEmailForm />
    </>
  );
};

export default SendEmail;
